import { api } from "./api";

export const dashboardService = {
  fetchOverview(params) {
    return api.get("/dashboard/", { params });
  },
};

export default dashboardService;
